// react
import React, { useEffect, useState } from "react";

// context
import { UserAuth } from "context/AuthContext";

// @mui
import { ThemeProvider } from "@mui/material/styles";

// layouts
import { layoutRegistry } from "layouts/registry/layoutRegistry";
import { getLayoutKey } from "layouts/registry/getLayoutKey";

// A ---------------------------------------------------------------------- M

const LayoutSwitcher = ({ children, tag }) => {
  const { user, userCompany, conservSostL1 } = UserAuth();

  const [layoutConfig, setLayoutConfig] = useState({
    layout: layoutRegistry.default.layout,
    theme: layoutRegistry.default.theme,
  });

  useEffect(() => {
    const key = getLayoutKey(window.location.hostname, user, userCompany, conservSostL1, tag);

    setLayoutConfig((prev) => {
      const selected = layoutRegistry[key] || layoutRegistry.default;
      if (prev.layout === selected.layout && prev.theme === selected.theme) return prev;
      return selected;
    });
  }, [user, userCompany, conservSostL1, tag]);

  const LayoutComponent = layoutConfig.layout;
  const theme = layoutConfig.theme;

  return (
    <ThemeProvider theme={theme}>
      <LayoutComponent>{children}</LayoutComponent>
    </ThemeProvider>
  );
};

export default LayoutSwitcher;
